<template>
    <div class="intro" v-resize="resizeHandler">
        <div class="container">
            <div class="intro__inner d-flex justify-center align-center flex-column">
                <div class="title-h2 intro__title">{{title}}</div>
                <!--v-if="subtitle && (mobileSubtitle && actualWidth >= 600)"-->

                <div
                        v-if="subtitle"
                        class="title-h4 intro__subtitle"
                >
                    {{subtitle}}
                </div>
                <!--<div v-else class="title-h4 intro__subtitle">-->
                    <!--{{mobileSubtitle}}-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import resize from "@/mixins/resize";

    export default {
        mixins: [resize],

        computed: {
            ...mapGetters([
                'getClient',
            ]),

            currentRoute() {
                const ROUTE_NAME = this.$route.name;
                return ROUTE_NAME;

            },
            currentPath() {
                let FIRST_SEGMENT = this.$route.path.split('/').filter(Boolean).shift();
                let path = FIRST_SEGMENT === 'studios' ? 'studio' : 'members';

                return path;
            },


            title() {
                if (this.currentPath === 'studio') {
                    return this.$t(`${this.currentPath}.${this.currentRoute}.guess_title`)
                } else {
                    return this.$t(`${this.currentPath}.${this.currentRoute}.guess_title`, { name: this.capitalizeFirstLetter(this.getClient.first_name)})
                }

            },

            subtitle() {
                if(this.$t(`${this.currentPath}.${this.currentRoute}.guess_subtitle`).includes(`${this.currentPath}.${this.currentRoute}.guess_subtitle`)) {
                    return null
                } else {
                    return this.$t(`${this.currentPath}.${this.currentRoute}.guess_subtitle`)
                }
            },
//
//            mobileSubtitle() {
//                if(this.$t(`${this.currentPath}.${this.currentRoute}.guess_subtitle_mobile`).includes(`${this.currentPath}.${this.currentRoute}.guess_subtitle_mobile`)) {
//                    return null
//                } else {
//                    return this.$t(`${this.currentPath}.${this.currentRoute}.guess_subtitle_mobile`)
//                }
//            }
        },

        methods: {
            capitalizeFirstLetter(string) {
                if (string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                } else {
                    return ''
                }

            }
        }
    }
</script>

<style lang="sass" scoped>
.intro
    width: 100%
    height: 236px
    background-image: url('~@/assets/images/studio/banner.png')
    background-size: cover
    +sm
        height: 200px
    .container
        height: 100%

    &__inner
        height: 100%
        position: relative
        z-index: 1

    &__subtitle
        letter-spacing: 1px
        margin-top: 8px
        +sm
            margin-top: 12px

    &__title, &__subtitle
        color: $color--white
        text-align: center
</style>